import { AddressPost } from '../models/address-post';

export class FriendStudentPost { 

  constructor() {
    this.id = '';
    this.studentSchoolId = '';
    this.firstName = '';
    this.middleName = '';
    this.lastName = '';
    this.name = '';  // Do I need to be building and sending this to db?
    this.yearOfBirth = '';
    this.phone = '';
    this.cellPhone = '';
    this.email = '';
    this.address = new AddressPost();
    this.contactMethodId = null;
    this.studentTypeId = null;
    this.studentLoginId = null;
  }

  id: string;
  studentSchoolId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  name: string;
  yearOfBirth: string;
  phone: string;
  cellPhone: string;
  email: string;
  address: AddressPost;
  contactMethodId: string;
  studentTypeId: string;
  studentLoginId: string;
}



// WEBPACK FOOTER //
// ./src/app/models/friend-student-post.ts